import { mdiAccountMultiple } from '@lumapps/lumx/icons';

export const WIDGET_USER_LIST_TYPE = 'user';
export const WIDGET_USER_LIST_ICON = mdiAccountMultiple;
export const WIDGET_USER_LIST_EDITION_SCOPE = 'widget-user-list-edition';
